import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=230c64b6&scoped=true&"
var script = {}
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&id=230c64b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c64b6",
  null
  
)

export default component.exports